/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectSignDateDto } from './subjectSignDateDto.model';
import { NonCadastralContractOwnerParamDto } from './nonCadastralContractOwnerParamDto.model';
import { NonCadastralContractParcelDataDto } from './nonCadastralContractParcelDataDto.model';
import { NonCadastralContractRentDrupoz } from './nonCadastralContractRentDrupoz.model';
import { NonCadastralContractRentUnknown } from './nonCadastralContractRentUnknown.model';
import { ValorizationType } from './valorizationType.model';


export interface NonCadastralContractDto { 
    autoProlongationMonths?: number;
    autoProlongationMonthsUnit?: string;
    autoProlongationRepeatedly: boolean;
    contractDocumentTemplate?: number;
    contractNumber?: number;
    contractNumberCustom?: string;
    contractNumberFormat?: string;
    contractParamTemplate?: number;
    contractRentDrupozCollection?: Array<NonCadastralContractRentDrupoz>;
    contractRentUnknownCollection?: Array<NonCadastralContractRentUnknown>;
    contractYear?: number;
    counterpartyNumber?: string;
    cpds?: Array<NonCadastralContractParcelDataDto>;
    createIndividualDocuments?: boolean;
    documentNote?: string;
    durationMonths?: number;
    durationMonthsUnit?: string;
    durationToDate?: string;
    expirationDate?: string;
    firstNoticeAfterMonths?: number;
    firstNoticeAfterMonthsUnit?: string;
    furtherRentPossible?: boolean;
    id?: number;
    indefinite?: boolean;
    inflationLimit?: number | null;
    isWatched?: boolean;
    lastNoticeBeforeMonths?: number;
    lastNoticeBeforeMonthsUnit?: string;
    note?: string;
    noticePeriodMonths?: number;
    noticePeriodMonthsUnit?: string;
    ownerIds: Array<number>;
    ownerSignDates?: Array<SubjectSignDateDto>;
    ownerparams: Array<NonCadastralContractOwnerParamDto>;
    parcelIds?: Array<number>;
    parcelPriceAdds?: Array<number>;
    payTaxOwner?: boolean;
    paymentsFromEconomicYear?: boolean;
    payoutToId?: number;
    priceContract?: number;
    priceDeal?: number;
    priceDealPercentageValorization?: number | null;
    priceDealValorization?: number | null;
    rentType?: string;
    reqNewAppendixAfterReprice: boolean;
    reusedPreviousExpiration: boolean;
    signatureDate?: string;
    successiveSourceContractNumber?: string;
    taxConcerned?: boolean;
    taxOwner?: number;
    taxOwnerToId?: number;
    taxTenant?: number;
    tenantHasPreemption?: boolean;
    tenantIds: Array<number>;
    tenantSignDates?: Array<SubjectSignDateDto>;
    toEconomicYear: boolean;
    useRentDrupoz?: boolean;
    valorizationType: ValorizationType;
    valorizeOrInflateToDate?: string | null;
    watchReason?: string;
}
export namespace NonCadastralContractDto {
}


